<template>
  <div class="d-flex col-sm justify-content-center">
    <div class="container-fluid">
      <div class="row mb-1">
        <div class="col-6 col-sm-5 col-md-4 offset-md-2 "><!-- offset-sm-1 offset-md-3 /// col-xl-8 -->
          <select class="form-control custom-select" @change="selectChange" v-model="selected">
            <option v-for="(name, type) in loadedCyphers" :key="type" :value="type">
              {{ name }}
            </option>
            <!--                        <option label="" value="MORSE">Morseovka</option>-->
            <!--                        <option label="" value="SPIDER">Pavouk</option>-->
          </select>
        </div>
        <div class="col-6 col-sm-4 col-md-2"><!-- col-xl-8 -->
          <input class="form-control " v-model="missing" ref="missingInput" :disabled="missingDisabled"
                 title="Chybějící znaky v abecedě šifry"
                 @change="validateMissing"/>
          <div class="form-check  form-check-inline" data-toggle='tooltip' data-placement='right'
               title="Ch neni písmenko, ale jestli tu věc potrebuješ ;) ..">
            <input class="form-check-input" id="checkbox" type="checkbox" v-model="hasCh"
                   name="hasCh" :disabled="hasChDisabled"/>
            <label class="form-check-label" for="checkbox">Ch?</label>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-2">
          <input class="form-control  " v-model="separator" v-if="separator!==null&&separator!==undefined"
                 placeholder="Oddělovač" :name="separator"
                 title="Oddělovací znak"
          />
        </div>
      </div>
      <div class="row" v-if="countParams>0">
        <div class="offset-lg-2"></div>
        <div v-for="c in countParams"
             :class="[`col-${Math.floor(12/countParams)}`,`col-lg-${Math.floor(8/countParams)}`]" :key="c">
          <input class="form-control " v-model="params[c]" :placeholder="paramsPlaceholders[c-1]"
                 :title="paramsPlaceholders[c-1]" :name="c"
                 @change="onChangedParams" @input="(opts)=>validateParams(opts,c-1)">
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-8 offset-lg-2"><!-- col-xl-2 -->
          <textarea class="form-control"
                    @input="autoHeight"
                    v-model="inputText"
                    placeholder="Vstupní text">
                    </textarea>
        </div>
        <!--                <div class="col">&lt;!&ndash; col-xl-2 &ndash;&gt;-->

        <!--                </div>-->
      </div>
      <div class="row justify-content-center">
        <div class="col-auto pr-0 pl-0"><!-- col-xl-2 -->
          <button type="button" class="btn btn-dark mr-1" :disabled="this.allowCypher()" @click="cypher">
            Šifrovat
          </button>
        </div>
        <div class="col-auto pr-0 pl-0 text-center"><!-- col-xl-2 -->
          <button type="button" class="btn btn-dark mr-1" :disabled="this.allowDecypher()" @click="decypher">
            Dešifrovat
          </button>
        </div>
        <div class="col-auto pr-0 pl-0 text-center" v-if="graphicalDecypher"><!-- col-xl-2 -->
          <button type="button"  class="btn btn-dark" @click="showDecypher">
            {{ this.showedDecypher ? "Skrýt" : "Ukázat" }} šifru
          </button>
        </div>
        <div class="col-auto pr-0 pl-0 text-center"  v-if="beeper"><!-- col-xl-2 -->
          <div class="input-group ">
            <div class="input-group-prepend">
              <button type="button" v-if="!isBeeping" class="btn btn-dark" @click="playBeeper">
                Vypípat
              </button>
              <button type="button" v-else class="btn btn-dark" @click="stopBeeper">
                Stop
              </button>
            </div>
            <input class=" form-control " style="width: 4em;padding-left: 0.25em"
                   type="number" min="50" max="500" step="25"
                   v-model="duration" data-toggle='tooltip' data-placement='right'
                   title="Délka tečky v milisekundách"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <ul v-if="errors.length">
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col col-lg-8 offset-lg-2"><!-- col-xl-2 -->
          <textarea class="form-control form-control-plaintext"
                    id="outputTextareaId"
                    ref="outputTextarea"
                    placeholder="Výstup"
                    :value="outputText"
                    readonly
                    v-if="!graphicalMethod"

          >
                    </textarea>
          <button v-if="!graphical" @click='printTextArea' class="btn btn-sm btn-dark float-right d-none d-md-block">
            Print
          </button>
          <div v-if="graphicalDecypher" class="text-center m-1" id="decypherTable" ref="outputTable"></div>
          <div v-if="graphical" class="m-1" id="canvasSpace" ref="outputSvg"></div>
          <button v-if="graphical" @click="clearCanvas('canvasSpace')" class="btn btn-sm btn-danger float-right">Clear
          </button>
          <button v-if="graphical" @click='print' class="btn btn-sm btn-dark float-right d-none d-md-block mr-1">Print
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Cyphers,
  CyphersType,
  CyphersCharMissing,
  CyphersCharCheckMissing,
  CyphersChIsChar,
  CyphersParamsPlaceholder,
  CyphersParams,
  CyphersBothway,
  Graphical,
  methods,
  drawMethod,
  drawDecryptTableMethod, CyphersParamsValidation
} from './components/cyphers/cyphers.js';

import {SVG} from '@svgdotjs/svg.js'
import {CypherBeeper,CypherSeparator} from "@/components/cyphers/cyphers";
import BackArrow from "./components/BackArrow";
/* eslint-disable vue/no-unused-components*/
export default {
  name: "Cyphers",
  components: {BackArrow},
  data: function () {
    let defaultCypher = this.$route.query.cypher
    defaultCypher = (defaultCypher || "").toUpperCase();
    if (!Cyphers[defaultCypher]) {
      defaultCypher = 'MORSE'
    }
    let defaultMissing = this.$route.query.missing || CyphersCharMissing[defaultCypher] ? CyphersCharMissing[defaultCypher].join(', ') : ''
    let defaultInputText = this.$route.query.input || ''
    let autoCypher = this.$route.query.autoCypher || this.$route.query.autocypher;
    let autoDecypher = this.$route.query.autoDecypher || this.$route.query.autodecypher;
    let params = (this.$route.query.params ? [null, ...this.$route.query.params.split(',')] : null) || {}; //params
    let hasChi = this.$route.query.hasCh === undefined ? CyphersChIsChar[defaultCypher] : this.$route.query.hasCh;
    setTimeout(() => {
      if (autoCypher || autoCypher !== undefined) {
        console.log('Timeouted now cyphering')
        this.cypher();
      } else if (autoDecypher || autoDecypher !== undefined) {
        console.log('Timeouted now deciphering')
        this.decypher();
      }
    }, 250);
    return {
      selected: defaultCypher,
      inputText: defaultInputText,
      loadedCyphers: Cyphers,
      graphical: CyphersType[defaultCypher] === Graphical,
      graphicalMethod: drawMethod[defaultCypher],
      graphicalDecypher: drawDecryptTableMethod[defaultCypher],
      missing: defaultMissing,
      missingDisabled: CyphersCharMissing[defaultCypher] == null,
      missingCheck: CyphersCharCheckMissing[defaultCypher],
      bothwayCyphering: CyphersBothway[defaultCypher] === '' ? true : CyphersBothway[defaultCypher],
      disabledBtns: false,
      errors: [],
      autoHeigthIn: '',
      autoHeigthOut: '',
      outputText: '',
      separator: CypherSeparator[defaultCypher],//"",
      hasCh: hasChi ,
      hasChDisabled: CyphersChIsChar[defaultCypher] == null,
      countParams: CyphersParams[defaultCypher],
      // hasParams: CyphersParams[defaultCypher] > 0,
      params: params,
      paramsPlaceholders: CyphersParamsPlaceholder[defaultCypher],
      beeper: CypherBeeper[defaultCypher],
      isBeeping: false,
      duration: 150,
      showedDecypher: false,
    }
  },
  methods: {
    selectChange: function () {
      // let newQuery = {query:{...this.$route.query}}
      // newQuery["cypher"]= this.selected
      // this.$router.push(newQuery);
      this.outputText = "";
      this.graphical = CyphersType[this.selected] === Graphical;
      this.graphicalMethod = drawMethod[this.selected];
      this.graphicalDecypher = drawDecryptTableMethod[this.selected];
      this.missing = CyphersCharMissing[this.selected] ? CyphersCharMissing[this.selected].join(', ') : '';
      this.missingDisabled = CyphersCharMissing[this.selected] == null;
      this.missingCheck = CyphersCharCheckMissing[this.selected];
      this.errors = [];
      this.separator = CypherSeparator[this.selected];//"";
      this.$refs.missingInput.classList.remove('is-invalid');
      this.disabledBtns = false;
      this.bothwayCyphering = CyphersBothway[this.selected] === '' ? true : CyphersBothway[this.selected];
      this.hasCh = CyphersChIsChar[this.selected];
      this.hasChDisabled = CyphersChIsChar[this.selected] == null;
      this.countParams = CyphersParams[this.selected];
      this.paramsPlaceholders = CyphersParamsPlaceholder[this.selected];
      this.showedDecypher = false;
      this.beeper = CypherBeeper[this.selected] === undefined ? false : CypherBeeper[this.selected];
      // console.log(this.beeper);
      try {
        drawDecryptTableMethod[this.selected] && this.clearCanvas('decypherTable');
        drawMethod[this.selected] && this.clearCanvas('canvasSpace');
        for (let ix = 1; ix <= CyphersParams[this.selected]; ix++)
          this.params[ix] = ""
      } catch (e) {
        console.warn(e);
      }
      //   validateParams()
    },
    cypher: function () {
      // debugger  // eslint-disable-line
      let missing = this.getMissingArr()

      if (!this.graphical) {
        if (this.separator != "" && this.separator != null) {
          this.outputText = methods[this.selected]['cypher'](this.inputText, this.hasCh, missing, this.params, this.separator)
        } else {
          this.outputText = methods[this.selected]['cypher'](this.inputText, this.hasCh, missing, this.params)
        }
        setTimeout(() => {
          this.autoHeight({target: this.$refs.outputTextarea})
        }, 10)
      } else {
        let cyphered = methods[this.selected]['cypher'](this.inputText, this.hasCh, missing, this.params)
        if (this.selected == 'CHINASE') {
          this.outputText = cyphered.map((a) => ("[" + a.join(',') + "]")).join(' ; ');
        } else {
          this.outputText = cyphered;
        }

        setTimeout(() => {
          this.autoHeight({target: this.$refs.outputTextarea});
        }, 10)
        this.clearCanvas();
        this.graphicalMethod && this.graphicalMethod(SVG(), cyphered);

      }

    },
    decypher: function () {
      // debugger  // eslint-disable-line
      let missing = this.getMissingArr()//this.missing ? (this.missing || '').split(',').map((c) => c.trim()).filter(item => item) : [];
      if (!this.graphical) {
        if (this.separator != "" && this.separator != null) {
          this.outputText = methods[this.selected]['decypher'](this.inputText, this.hasCh, missing, this.params, this.separator)
        } else {
          this.outputText = methods[this.selected]['decypher'](this.inputText, this.hasCh, missing, this.params)
        }
        setTimeout(() => {
          this.autoHeight({target: this.$refs.outputTextarea})
        }, 10)
      } else {
        let decyphered = methods[this.selected]['decypher'](this.inputText, this.hasCh, missing, this.params)
        this.outputText = decyphered;
      }
    },
    clearCanvas: function (id = 'canvasSpace') {
      SVG().addTo("#" + id).parent().clear()
    },
    print: function () {
      let mywindow = window.open('', 'PRINT', 'height=768,width=1024');

      mywindow.document.write('<html><head><title>' + document.title + '</title>');
      mywindow.document.write('</head><body >');
      mywindow.document.write(document.getElementById("canvasSpace").innerHTML);
      mywindow.document.write('</body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();

      return true;
    },
    printTextArea: function () {
      let mywindow = window.open('', 'PRINT', 'height=768,width=1024');

      mywindow.document.write('<html><head><title>' + document.title + '</title>');
      mywindow.document.write('</head><body >');
      // mywindow.document.write('<h1>' + document.title  + '</h1>');
      mywindow.document.write(document.getElementById("outputTextareaId").value);
      mywindow.document.write('</body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();

      return true;
    },
    showDecypher: function () {
      if (this.showedDecypher) {
        this.showedDecypher = !this.showedDecypher;
        this.clearCanvas("decypherTable");
        return
      }
      if (this.graphicalDecypher) {
        this.clearCanvas("decypherTable");
        let tableCanvas = SVG().addTo('#decypherTable');
        console.table({width: window.innerWidth,height: window.innerHeight})
        let divTable = document.getElementById('decypherTable');
        console.log(divTable);
        console.table({width: divTable.clientWidth});
        // tableCanvas.
        // tableCanvas.size(null,divTable.clientWidth);
        // tableCanvas.preserveAspectRatio="meet" //preserveAspectRatio="meet" viewBox="0 0 400 400"
        this.graphicalDecypher(tableCanvas, this.getMissingArr(), this.params, this.hasCh);
        // tableCanvas.attr('viewBox',`0 0 ${divTable.clientWidth} ${divTable.clientWidth}`) //preserveAspectRatio="meet" viewBox="0 0 400 400"
        // tableCanvas.attr('viewBox','0 0 400 400') //preserveAspectRatio="meet" viewBox="0 0 400 400"
        // tableCanvas.attr("width","100%")
        // tableCanvas.attr("height","auto")
        this.showedDecypher = !this.showedDecypher;
      }
    },
    autoHeight: function (opts) {
      if (opts.target) {
        opts.target.style.height = "auto";
        opts.target.style.height = `${opts.target.scrollHeight + 8}px`;
      }

    },
    getMissingArr: function () {
      return this.missing ? (this.missing || '').split(/[, ]/).map((c) => c.trim()).filter(item => item) : [];
    },
    validateMissing: function (opts) {
      if (!this.missingCheck) {
        return
      }
      let neededChars = CyphersCharMissing[this.selected].length
      let parsed = opts.target.value.split(/[, ]/).map((c) => c.trim()).filter(item => item);
      if (parsed.length !== neededChars) {
        this.disabledBtns = true
        this.errors.push("Špatný počet znaků chybjících v abecedě šifry")
        opts.target.classList.add("is-invalid")
      } else {
        this.disabledBtns = false
        this.errors.splice(0, this.errors.length)
        opts.target.classList.remove("is-invalid")
      }
      this.onChangedParams()
    },
    validateParams: function (opts, ix) {
      // console.log(opts)
      // console.log(ix)
      // console.log(CyphersParamsValidation[this.selected][ix])
      // console.log(opts.target.value.match(CyphersParamsValidation[this.selected][ix]))
      let matched = opts.target.value.match(CyphersParamsValidation[this.selected][ix])
      if (matched) {
        this.params[ix + 1] = matched[0]
        this.disabledBtns = false
        this.errors.splice(0, this.errors.length)
        opts.target.classList.remove("is-invalid")
      } else {
        this.disabledBtns = true
        if (this.errors.indexOf("Špatně zadaný parametr šifry") < 0)
          this.errors.push("Špatně zadaný parametr šifry")
        opts.target.classList.add("is-invalid")
      }

    },
    allowCypher: function () {
      if (this.disabledBtns) return this.disabledBtns;
      if (this.bothwayCyphering !== true) {
        if (this.bothwayCyphering === 'cypher') return false;
        return true
      }
      return false
    },
    allowDecypher: function () {
      if (this.disabledBtns) return this.disabledBtns;
      if (this.bothwayCyphering !== true) {
        if (this.bothwayCyphering === 'decypher') return false;
        return true
      }
      return false
    },
    onChangedParams: function (opts) {
      if (this.showedDecypher) {
        this.showedDecypher = false;
        this.showDecypher();
      }

    },
    playBeeper: function () {
      this.cypher();
      if(!this.isBeeping){
        this.isBeeping = true;
        this.beeper(this.outputText,parseInt(this.duration), ()=>{this.isBeeping=false})
      }
    },
    stopBeeper: function () {
      if(this.isBeeping){
        methods[this.selected]['stopBeeping']();
        this.isBeeping = false;
      }
    },
    prepareUrlQuery:function () {
      const query = {};
      // return {
      query.cypher = this.selected;
      if (this.hasCh !== null)
        query.hasCh = this.hasCh;
      let pars=[];
      if (this.params && this.countParams>=1) {
        for (let i = 1; this.countParams >= i; i++) {
          let param = this.params[i];
          if(param.toString().includes(',')){
            param = param.replace(',',' ');
          }
          pars.push(param);
        }
        query.params = pars.join(',');
      }
      // }
      return query;
    },
  },
  watch: {
    hasCh: function (val) {
      this.onChangedParams()
      this.$root.replaceUrlQuery(this.prepareUrlQuery());
    },
    separator: function () {
      this.$root.replaceUrlQuery(this.prepareUrlQuery());
    },
    params:function () {
      this.$root.replaceUrlQuery(this.prepareUrlQuery());
    }
  }
}
</script>

<style scoped>
textarea { /*,canvas*/
  padding: 0.2rem;
  margin: 0.5rem 0.5rem 0.5rem 0rem;
}

textarea[readonly] {
  background-color: #FFF !important;
}

#canvasSpace {
  /*border: #2c3e50 1px solid;*/
  min-height: 2em;
  border: 1px solid #ced4da;
  border-radius: .25rem;
}

#decypherTable {
  width: 100%;
  overflow-y: auto;
}

</style>